import type { ReactNode } from 'react';

import { ClaudeLogoIcon, GrokBotLogoIcon, OpenAILogoIcon } from '@/components/icons/svgs';

import { AI_AGENT_SLIDES } from '../../constants/landing-constants';
import { GlowThumbnail } from '../common/glow-thumbnail';

const ICON_CLASS = 'size-5 shrink-0';

/** The landing page's "Binary in Claude" screenshot, at the landing demo-thumbnail size with its glow. */
const HERO_IMAGE = AI_AGENT_SLIDES[0];

const MCP_HERO_CLIENTS: { name: string; logo?: ReactNode }[] = [
	{ name: 'Claude', logo: <ClaudeLogoIcon className={ICON_CLASS} /> },
	{
		name: 'ChatGPT',
		logo: <OpenAILogoIcon className={`${ICON_CLASS} text-primary`} />,
	},
	{
		name: 'Grok',
		logo: <GrokBotLogoIcon className={`${ICON_CLASS} text-primary`} />,
	},
	{ name: 'Codex' },
	{ name: 'Cursor' },
	{ name: 'Claude Code' },
];

export const McpHeroSection = () => {
	return (
		<section className="landing-width mb-24 flex w-full flex-col items-center px-4 text-center md:mb-32 md:px-8">
			<span className="mt-8 w-fit rounded-full border border-border bg-background px-4 py-1.5 text-sm font-medium text-slate-700 md:mt-0">
				Model Context Protocol (MCP) server
			</span>

			<h1 className="landing-heading mt-4 w-full text-balance !bg-none !text-[32px] !text-primary tracking-tight md:!text-[48px]">
				The ATS MCP server for Claude &amp; ChatGPT
			</h1>

			<p className="mt-5 max-w-3xl text-pretty text-base leading-relaxed text-[hsl(215_20%_38%)] md:mt-6 md:max-w-xl md:text-[1.375rem] md:leading-8">
				Screen candidates, import data, create jobs and schedule interviews from your AI assistant.
				Read and write, included on every plan, including Free.
			</p>

			<ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
				{MCP_HERO_CLIENTS.map((client) => (
					<li
						key={client.name}
						className="flex items-center gap-1.5 text-sm font-medium text-primary/80"
					>
						{client.logo}
						<span>{client.name}</span>
					</li>
				))}
			</ul>

			<GlowThumbnail
				src={HERO_IMAGE.src}
				alt={HERO_IMAGE.alt}
				width={1800}
				height={1120}
				size="lg"
				className="mt-8 md:mt-10"
			/>
		</section>
	);
};
